
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"172","height":"155","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M79.786 11C49.566 11 19.648 19.585 5.9 44.154-1.21 56.87-1.944 73.808 3.965 88.35c5.396 13.236 15.17 22.486 27.539 26.051 25.322 7.294 49.601-11.796 70.998-28.656 2.363-1.854 4.666-3.669 6.904-5.391 5.725-4.405 11.704-8.744 18.1-12.745 21.586-13.514 16.218-46.575-8.58-52.156l-.87-.197C106.108 12.62 92.923 11 79.786 11z","fill":"#5C8AE2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.54 79.068c-2.743-.253-2.86-.77-3.211-3.466-.553-4.334-1.666-8.51-2.086-12.956-.538-3.727-1.015-7.388-1.308-11.067-.06-2.26.373-2.527 2.508-2.807.067.034.407-.058.617-.033 8.402.588 16.626-1.518 24.968-1.713a30.636 30.636 0 005.16-.507c7.117-1.118 14.267-.648 21.388-.295 9.244.638 18.698 1.3 28.043 2.022 3.386.26 3.373.028 3.518-3.295.247-5.603.657-11.124 1.419-16.732.131-1.191.443-2.351.784-4.066 15.984 12.637 30.185 26.56 44.214 40.902-.853 1.188-1.609 2.383-2.473 3.465-4.401 5.462-8.631 11.098-13.339 16.279-4.573 5.035-9.38 9.834-14.978 13.89-4.987 3.771-10.192 7.388-14.379 12.403-.471.544-1.344.973-2.246 1.734-.55-.968-.926-1.892-1.127-2.732-1.554-6.519-3.205-13.045-4.524-19.624-.691-2.752-.577-6.065-.635-9.086-.066-2.502-.937-3.39-3.317-3.031-7.132 1.059-14.256 2.272-21.438 3.078-3.433.284-6.743-.055-10.046-.167-6.889-.39-13.416-.54-20.215-.76-5.708-.507-11.516-.929-17.298-1.436z","fill":"#F9A91E"}})])
          )
        }
      }
    